<div class="full-page registration-bg container-fluid w-100 d-flex flex-column align-items-center mt-0 justify-content-evenly">
  <img class="home-logo mt-4" src="assets/images/Logos/Redbullslogo.svg" draggable="false" />
  <div class="content-container d-flex align-items-center">
    <router-outlet></router-outlet>
  </div>
</div>
